<template>
    <section>
        <Dialog 
            v-model:visible="context.isLanguageModalOpen" 
            :header="translate('choose a language', 'ucfirst')" 
            modal 
            class=bg-white 
            :closeOnEscape="true" 
            :dismissableMask="true" 
            :draggable="false"
            :style="{ width: '30rem' }"
            @hide="closeDialog()"
        >
            <div class="flex flex-col gap-4">
                <RectangularButton 
                    v-for="item, index of languagesList" 
                    :key="index" 
                    :type="'DARK'" 
                    :textContent="item.getName(true, true)" 
                    :class="item.code == context.getLang ? 'opacity-75' : ''"
                    :disabled="item.code == context.getLang"
                    @click.prevent="changeLanguage(item.code)"
                />

            </div>
        </Dialog>
    </section>
</template>

<script setup>
    import { onMounted, defineEmits, ref } from 'vue';
    import { Dialog } from 'primevue';
    import LanguageService from '@/services/LanguageService';
    import { translate } from '@/composables/translate';
    import { useContextStore } from '@/stores/context';
    import RectangularButton from '../misc/RectangularButton.vue';

    const context = useContextStore();
    let languagesList = ref([]);
    const emit = defineEmits(["closed"]);

    onMounted(() => {
        getLanguages();
    });

    async function getLanguages() {
        const langs = await LanguageService.getLanguages();
        languagesList.value = langs.parsedItems();
    }

    async function changeLanguage(langCode = 'pt') {
        if (context.getLang != langCode) {
            context.setLang(langCode);
        }
        closeDialog();
    }

    function closeDialog() {
        emit("closed", true);
    }

</script>